export default function SectionHeader({ eyebrow, title, description, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs mb-4">{eyebrow}</p>
      )}
      <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-[#0a1128]">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed max-w-2xl">
          {description}
        </p>
      )}
    </div>
  );
}
